import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
@Injectable({ providedIn: 'root' })
export class AxinomDrmService {

  private readonly WV_URL = 'toqqer_axinom_wv_url';
  private readonly FP_URL = 'toqqer_axinom_fp_url';
  private readonly WV_TOKEN = 'toqqer_axinom_wv_token';
  private readonly FP_TOKEN = 'toqqer_axinom_fp_token';

  constructor(private http: HttpClient) {}

  private isSafariApple(): boolean {
    const ua = navigator.userAgent;
    const isApple = /Macintosh|iPad|iPhone|iPod/.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    return isApple && isSafari;
  }

  async loadDrmData(userId: string): Promise<void> {
    const isApple = this.isSafariApple();
    if (isApple) {
      const fairplayUrl = localStorage.getItem(this.FP_URL);
      const fairplayToken = localStorage.getItem(this.FP_TOKEN);
      if (fairplayUrl && fairplayToken) return;
      const fp: any = await this.http.get(`${environment.TQR_SERVICE}axinom/license/fairplay/keyId?userId=${userId}`).toPromise();
      localStorage.setItem(this.FP_URL, fp.licenseUrl);
      localStorage.setItem(this.FP_TOKEN, fp.headerMap['X-AxDRM-Message']);
    } else {
      const widevineUrl = localStorage.getItem(this.WV_URL);
      const widevineToken = localStorage.getItem(this.WV_TOKEN);
      if (widevineUrl && widevineToken) return;
      const wv: any = await this.http.get(`${environment.TQR_SERVICE}axinom/license/widevine/keyId?userId=${userId}`).toPromise();
      localStorage.setItem(this.WV_URL, wv.licenseUrl);
      localStorage.setItem(this.WV_TOKEN, wv.headerMap['X-AxDRM-Message']);
    }
  }

  getWidevineUrl(): string {
    return localStorage.getItem(this.WV_URL)!;
  }

  getFairPlayUrl(): string {
    return localStorage.getItem(this.FP_URL)!;
  }

  getFairplayToken(): string {
    return localStorage.getItem(this.FP_TOKEN);
  }

  getWidevineToken(): string {
    return localStorage.getItem(this.WV_TOKEN);
  }

  // getToken(): string {
  //   return localStorage.getItem(this.TOKEN)!;
  // }

  getFairPlayCertUrl(): string {
    return 'https://dev.toqqer.com/toqqer/static/post_videos/fairplay.cer';
  }
}

